// extracted by mini-css-extract-plugin
export default {"base":"Center_base__ciqpw","base--inline":"Center_base--inline__FpNll","base--direction-column":"Center_base--direction-column__Xm2wj"};